import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14.778} height={15.061} {...props}>
    <g data-name="Clock 15 A" transform="translate(64.158 -8432)">
      <path
        data-name="Path 4740"
        d="M-56.815 8446.831a7.043 7.043 0 0 1-5.051-2.171 7.4 7.4 0 0 1 .049-10.307 7.046 7.046 0 0 1 5.047-2.124h.044a7.239 7.239 0 0 1 7.114 7.345 7.329 7.329 0 0 1-2.112 5.133 7.045 7.045 0 0 1-5.048 2.123Z"
        fill="#ffc600"
      />
      <path
        data-name="Path 4741"
        d="M-56.769 8432.459h.043a7.073 7.073 0 0 1-.044 14.142h-.043a7.073 7.073 0 0 1 .044-14.142m0-.459a7.275 7.275 0 0 0-5.211 2.192 7.633 7.633 0 0 0-.05 10.627 7.27 7.27 0 0 0 5.214 2.241h.046a7.274 7.274 0 0 0 5.211-2.192 7.632 7.632 0 0 0 .05-10.627 7.27 7.27 0 0 0-5.214-2.241Z"
        fill="#102770"
      />
      <path
        data-name="Path 4742"
        d="M-49.84 8439.573a7.111 7.111 0 0 0-2.631-5.59 7.119 7.119 0 0 1 2.158 5.171 7 7 0 0 1-6.973 7.028 6.813 6.813 0 0 1-4.255-1.523 6.831 6.831 0 0 0 4.729 1.943 7 7 0 0 0 6.972-7.029Z"
        fill="#bd9301"
      />
      <path
        data-name="Path 4743"
        d="M-51.065 8439.732a5.6 5.6 0 0 0-4.109-5.471l-.044.164.044-.164a5.446 5.446 0 0 0-5.284 1.441 5.667 5.667 0 0 0 2.472 9.433 5.424 5.424 0 0 0 1.371.184 5.575 5.575 0 0 0 5.55-5.587Z"
        fill="#ffe58b"
      />
      <path
        data-name="Path 4744"
        d="M-56.804 8445.01a5.285 5.285 0 0 1-3.791-1.629 5.5 5.5 0 0 1-1.548-3.882 5.44 5.44 0 0 1 5.373-5.445h.033a5.285 5.285 0 0 1 3.791 1.629 5.5 5.5 0 0 1 1.548 3.882 5.44 5.44 0 0 1-5.373 5.445Z"
        fill="#fff"
      />
      <path
        data-name="Path 4745"
        d="M-56.769 8434.248h.032a5.283 5.283 0 0 1-.033 10.563h-.032a5.283 5.283 0 0 1 .033-10.564m0-.393a5.484 5.484 0 0 0-3.928 1.652 5.7 5.7 0 0 0-1.642 3.989 5.63 5.63 0 0 0 5.535 5.709h.034a5.482 5.482 0 0 0 3.928-1.652 5.751 5.751 0 0 0 .038-8.009 5.48 5.48 0 0 0-3.931-1.689Z"
        fill="#102770"
      />
      <path
        data-name="Path 4746"
        d="M-61.069 8442.533a5.356 5.356 0 0 1-.91-3.034 5.275 5.275 0 0 1 5.209-5.282h.032a5.18 5.18 0 0 1 4.629 2.94l-.057.033a5.12 5.12 0 0 0-4.213-2.284h-.032a5.21 5.21 0 0 0-5.144 5.218 5.277 5.277 0 0 0 .541 2.377Z"
        fill="#d9d9d9"
      />
      <ellipse
        data-name="Ellipse 60"
        cx={0.875}
        cy={0.857}
        rx={0.875}
        ry={0.857}
        transform="rotate(-80.567 4950.39 4254.247)"
        fill="#102770"
      />
      <path
        data-name="Path 4748"
        d="m-59.286 8437.336 2.246 2.473a.213.213 0 0 0 .364-.094.212.212 0 0 0-.048-.189l-2.213-2.5a.213.213 0 0 0-.3-.017l-.033.029a.213.213 0 0 0-.016.298Z"
        fill="#102770"
      />
      <path
        data-name="Path 4749"
        d="m-56.613 8438.933 1.4-1.9a.46.46 0 0 1 .665-.079.46.46 0 0 1 .073.628l-1.73 2.318Z"
        fill="#102770"
      />
      <path
        data-name="Path 4750"
        d="m-56.499 8440.318.523.586a.121.121 0 0 0 .17.01l.151-.133a.119.119 0 0 0 .008-.17l-.565-.61Z"
        fill="#102770"
      />
      <path
        data-name="Path 4751"
        d="M-56.722 8432.459a6.8 6.8 0 0 0-3.489.936 7.012 7.012 0 0 0-1.912 1.653 7.172 7.172 0 0 0 .921 9.915 7.172 7.172 0 0 1-.6-9.9 2.061 2.061 0 0 0 1.051-.675 2.548 2.548 0 0 0 .42-.627 6.823 6.823 0 0 1 8.194.509 6.826 6.826 0 0 0-4.585-1.811Z"
        fill="#ffe58b"
      />
    </g>
  </svg>
);

export default SvgComponent;
